import React from "react";
import { Box, Typography } from "@mui/material";

import { IActivityLogsData } from "../../../api/agentActivityLog/index.types";
import TableHead from "./Components/TableHead";
import TableBody from "./Components/TableBody";
import { ContainerWithLoader, FilterSearch, PaginationWithLimit } from "../index";
import { ISortBy } from "../../../types";
import { IPaginationState } from "../../../hooks/usePagination";
import { TABLE_COLUMNS } from "./constants";
import { ActiveFilter, FilterOption } from "../FilterSearch";

interface IProps {
  loading: boolean;
  logs: IActivityLogsData[];
  count: number;
  pagination: Omit<IPaginationState, "setCount">;
  handleSort: [ISortBy, (sortBy: ISortBy) => void];
  tableColumns?: string[];
  activeFilters?: ActiveFilter[];
  setActiveFilters: (filters: Record<string, ActiveFilter>) => void;
  filterOptions: FilterOption[];
  defaultSearchFilters?: string[];
}
const LogsHistoryTable: React.FC<IProps> = ({
  loading,
  logs,
  pagination,
  count,
  handleSort,
  tableColumns = TABLE_COLUMNS,
  setActiveFilters,
  activeFilters = [],
  filterOptions,
  defaultSearchFilters,
}) => {
  const [sortBy, setSortBy] = handleSort;

  return (
    <Box className="discounts" my="20px">
      <Box display="flex" justifyContent="space-between" mb="10px">
        <Box width="100%">
          <FilterSearch
            initialFilters={Object.values(activeFilters)}
            handleSearch={setActiveFilters}
            filterOptions={filterOptions}
            placeholder="Click to select filter option "
            defaultSearchFilters={defaultSearchFilters}
          />
        </Box>
      </Box>

      <Typography my="5px">
        Logs found:<b>{count}</b>
      </Typography>

      <Box sx={{ overflowX: "scroll" }}>
        <ContainerWithLoader isLoading={loading} report={logs} noResultsMessage="There are no logs">
          <Box component="table" width="100%">
            <TableHead handleSort={[sortBy, setSortBy]} tableColumns={tableColumns} />
            <TableBody logs={logs} tableColumns={tableColumns} />
          </Box>
        </ContainerWithLoader>
      </Box>

      <div>
        <PaginationWithLimit
          count={pagination.count}
          limit={pagination.limit}
          page={pagination.page}
          setLimit={pagination.setLimit}
          setPageState={pagination.setPage}
        />
      </div>
    </Box>
  );
};

export default LogsHistoryTable;
